import React from 'react';
import { Points } from 'components/Points/Points';
import { ActivityStats } from 'types/interfaces/activity';
import './WelcomeHeader.css';

// The welcome header (Asana 1218957945501621, Decision 3): h1, a pulsing pink
// dot, and ONE live line. Every point value renders through <Points>.

interface Props {
  username: string;
  /** At least one completed trade: "Welcome back" */
  returning: boolean;
  stats: ActivityStats | undefined;
  /** VERIFY_PHONE not yet COMPLETED: the day-one second sentence */
  showFirstPointsNudge: boolean;
  /** VERIFY_PHONE's pointsReward from the checklist (pass 5: never a hardcoded amount) */
  firstPointsReward?: number;
  isLoading?: boolean;
}

const WelcomeHeader: React.FC<Props> = ({ username, returning, stats, showFirstPointsNudge, firstPointsReward = 0, isLoading = false }) => {
  const inTransit = stats?.inTransitCount ?? 0;
  const mine = stats?.mine ?? null;
  const arriving = mine && mine.arrivingToday > 0 && mine.arrivingTodayTo ? mine.arrivingTodayTo : null;
  const others = Math.max(inTransit - (mine?.inTransit ?? 0), 0);

  return (
    <header className="home-welcome" data-testid="home-welcome">
      <h1 className="home-welcome__title">{returning ? `Welcome back, ${username}` : `Welcome, ${username}!`}</h1>
      <p className="home-welcome__live" data-testid="home-welcome-live" aria-live="polite">
        <span className="home-welcome__dot" aria-hidden="true" />
        {isLoading && !stats ? (
          <span className="home-welcome__loading">Counting packages in the mail…</span>
        ) : arriving ? (
          <>
            Your package to {arriving} arrives today. {others.toLocaleString('en-US')} others are in the mail right now.
          </>
        ) : (
          <>
            {inTransit.toLocaleString('en-US')} packages are in the mail between traders right now.
            {showFirstPointsNudge && firstPointsReward > 0 && (
              <>
                {' '}
                Your first <Points type="inline" points={firstPointsReward} /> is one minute away.
              </>
            )}
          </>
        )}
      </p>
    </header>
  );
};

export default WelcomeHeader;
